import React from 'react';

const SimpleHomePage: React.FC = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f0f0f0', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ 
        backgroundColor: 'white', 
        padding: '2rem', 
        borderRadius: '8px', 
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '500px'
      }}>
        <h1 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          color: '#333', 
          marginBottom: '1rem' 
        }}>
          AI-PhysicsBook
        </h1>
        <p style={{ 
          color: '#666', 
          marginBottom: '2rem',
          fontSize: '1.2rem'
        }}>
          Trang chủ đã load thành công!
        </p>
        
                 <div style={{ 
           display: 'flex', 
           gap: '1rem', 
           justifyContent: 'center', 
           flexWrap: 'wrap' 
         }}>
           <button 
             onClick={() => window.location.href = '/auth-test'}
             style={{ 
               padding: '0.75rem 1.5rem', 
               backgroundColor: '#e65100', 
               color: 'white', 
               border: 'none', 
               borderRadius: '6px',
               fontWeight: '500',
               cursor: 'pointer'
             }}
           >
             Test Google Login
           </button>
           <button 
             onClick={() => window.location.href = '/test-auth'}
             style={{ 
               padding: '0.75rem 1.5rem', 
               backgroundColor: '#28a745', 
               color: 'white', 
               border: 'none', 
               borderRadius: '6px',
               fontWeight: '500',
               cursor: 'pointer'
             }}
           >
             Test Auth Page
           </button>
           <button 
             onClick={() => window.location.href = '/test'}
             style={{ 
               padding: '0.75rem 1.5rem', 
               backgroundColor: '#2563eb', 
               color: 'white', 
               border: 'none', 
               borderRadius: '6px',
               fontWeight: '500',
               cursor: 'pointer'
             }}
           >
             Test Page
           </button>
         </div>
        
                 <div style={{ marginTop: '2rem', fontSize: '0.9rem', color: '#888' }}>
           <p>Server: <strong>http://localhost:3000</strong></p>
           <p>Thời gian: <strong>{new Date().toLocaleString()}</strong></p>
         </div>
      </div>
    </div>
  );
};

export default SimpleHomePage;
